const initialState = {
  newAuthForm: false,
  modality: {
    id: '',
    value: '',
  },
  communityBasedProvider: {
    id: '',
    value: '',
  },
  budgetType: {
    budTypeId: '',
  },
  authType: {
    athTypId: '',
  },
  fundingOrg: {
    id: '',
    value: '',
  },
  transferForm: {
    id: '',
    value: '',
  },
  initialReferral: {
    id: '',
    value: '',
  },
  athIssueDate: '',
  ext1IssueDate: '',
  ext2IssueDate: '',
  authorizedByOriginal: {
    id: '',
    value: '',
  },
  authorizedByExtension1: {
    id: '',
    value: '',
  },
  authorizedByExtension2: {
    id: '',
    value: '',
  },
  daysAuthorisedStartDate: '',
  ext1StartDate: '',
  ext2StartDate: '',
  daysAuthorisedQty: '',
  ext1DayQty: '',
  ext2DayQty: '',
  daysAuthorisedDayDelay: '',
  daysAuthorisedEndDate: '',
  daysAuthorisedEndDateChanged: 0,
  ext1EndDate: '',
  ext2EndDate: '',
  overAllStartDate: '',
  overallQty: '',
  overAllEndDate: '',
  unitsTotal: '',
  maxUnitsPerWeek: '',
  maxIndsPerWeek: '',
  maxGrpsPerWeek: '',
  cbpAdmitDate: '',
  cbpDischargeDate: '',
  authStartDate: '',
  authEndDate: '',
  placementType: {
    id: '',
    value: '',
  },
  relapse: {
    id: '',
    value: '',
  },
  authComment: '',
  completionSurveyAdministered: '',
  authIsLocked: '',
  administrativeTransferAdmit: {
    id: '',
    value: '',
  },
  authorizationReviewedBy: {
    id: '',
    value: '',
  },
  reviewDate: '',
};
export default initialState;
